export default {
      id: "icon-pro-usage",
      viewBox: "0 0 18 19",
      url: "../icon/" + "icons.svg#icon-pro-usage",
      toString: function () {
        return this.url;
      }
    }